module.exports = __webpack_public_path__ + "img/voltaje_a_blue.69c99e98.svg";